import styles from './styles/style.module.scss'

export const Preloader = () => {
   return <div className={styles.preloader}>Loading...</div>;
};
